import React from "react";
import { Table, Tbody, Td } from "./BiBleYear.style";

const ThreeZeroSixToThreeThreeFive = () => {
  return (
    <Table>
      <Tbody>
        <tr>
          <Td>306</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.4.THSV11">
              เอเสเคียล 4,5
            </a>
          </Td>
          <Td>ยากอบ 1</Td>
          <Td>Ezekiel 4,5</Td>
          <Td>James 1</Td>

          <Td>เผชิญการทดสอบ</Td>
        </tr>
        <tr>
          <Td>307</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.6.THSV11">
              เอเสเคียล 6,7
            </a>
          </Td>
          <Td>ยากอบ 2</Td>
          <Td>Ezekie 6,7</Td>
          <Td>James 2</Td>

          <Td>ให้สัญญาณเตือน</Td>
        </tr>
        <tr>
          <Td>308</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.8.THSV11">
              เอเสเคียล 8,9
            </a>
          </Td>
          <Td>สดุดี 119:121-144</Td>
          <Td>Ezekiel 8,9</Td>
          <Td>Pslams 119:121-144</Td>

          <Td>พระคำสำหรับวันนี้</Td>
        </tr>
        <tr>
          <Td>309</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.10.THSV11">
              เอเสเคียล 10,11
            </a>
          </Td>
          <Td>ยากอบ 3</Td>
          <Td>Ezekiel 10,11</Td>
          <Td>James 3</Td>

          <Td>เล่นกับไฟหรือ?</Td>
        </tr>
        <tr>
          <Td>310</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.12.THSV11">
              เอเสเคียล 12,13
            </a>
          </Td>
          <Td>ยากอบ 4</Td>
          <Td>Ezekiel 12,13</Td>
          <Td>James 4</Td>

          <Td>มือที่เปรอะเปื้อน</Td>
        </tr>
        <tr>
          <Td>311</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.14.THSV11">
              เอเสเคียล 14,15
            </a>
          </Td>
          <Td>ยากอบ 5</Td>
          <Td>Ezekiel 14,15</Td>
          <Td>James 5</Td>

          <Td>มิใช่ปราศจากเหตุผล</Td>
        </tr>
        <tr>
          <Td>312</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.16.THSV11">
              เอเสเคียล 16,17
            </a>
          </Td>
          <Td>สดุดี 119:145-176</Td>
          <Td>Ezekiel 16,17</Td>
          <Td>Pslams 119:145-176</Td>

          <Td>ช่วยกู้ได้บ้าง</Td>
        </tr>
        <tr>
          <Td>313</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.18.THSV11">
              เอเสเคียล 18,19
            </a>
          </Td>
          <Td>1 เปโตร 1</Td>
          <Td>Ezekiel 18,19</Td>
          <Td>1 Peter 1</Td>

          <Td>ขึ้นอยู่กับคุณ</Td>
        </tr>
        <tr>
          <Td>314</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.20.THSV11">
              เอเสเคียล 20,21
            </a>
          </Td>
          <Td>1 เปโตร 2</Td>
          <Td>Ezekiel 20,21</Td>
          <Td>1 Peter 2</Td>

          <Td>ออกจากความมืด</Td>
        </tr>
        <tr>
          <Td>315</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.22.THSV11">
              เอเสเคียล 22,23
            </a>
          </Td>
          <Td>สดุดี 120-122</Td>
          <Td>Ezekiel 22,23</Td>
          <Td>Psalms 120-122</Td>

          <Td>จะมีใครช่วยไหม?</Td>
        </tr>
        <tr>
          <Td>316</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.24.THSV11">
              เอเสเคียล 24,25
            </a>
          </Td>
          <Td>1 เปโตร 3</Td>
          <Td>Ezekiel 24,25</Td>
          <Td>1 Peter 3</Td>

          <Td>เรื่องที่ดุเดือด</Td>
        </tr>
        <tr>
          <Td>317</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.26.THSV11">
              เอเสเคียล 26,27
            </a>
          </Td>
          <Td>1 เปโตร 4</Td>
          <Td>Ezekiel 26,27</Td>
          <Td>1 Peter 4</Td>

          <Td>จากสิ่งสลักหักพัง</Td>
        </tr>
        <tr>
          <Td>318</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.28.THSV11">
              เอเสเคียล 28,29
            </a>
          </Td>
          <Td>1 เปโตร 5</Td>
          <Td>Ezekiel 28,29</Td>
          <Td>1 Peter 5</Td>

          <Td>เป็นกรณีที่หมดหวังหรือ?</Td>
        </tr>
        <tr>
          <Td>319</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.30.THSV11">
              เอเสเคียล 30,31
            </a>
          </Td>
          <Td>สดุดี 123-125</Td>
          <Td>Ezekiel 30,31</Td>
          <Td>Psalms 123-125</Td>

          <Td>จากนี้ไปนิรันดร์</Td>
        </tr>
        <tr>
          <Td>320</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.32.THSV11">
              เอเสเคียล 32,33
            </a>
          </Td>
          <Td>2 เปโตร 1</Td>
          <Td>Ezekiel 32,33</Td>
          <Td>2 Peter 1</Td>

          <Td>ฤทธิ์อำนาจของพระเจ้า</Td>
        </tr>
        <tr>
          <Td>321</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.34.THSV11">
              เอเสเคียล 34,35
            </a>
          </Td>
          <Td>2 เปโตร 2</Td>
          <Td>Ezekiel 34,35</Td>
          <Td>2 Peter 2</Td>

          <Td>แกะที่หลงหาย</Td>
        </tr>
        <tr>
          <Td>322</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.36.THSV11">
              เอเสเคียล 36,37
            </a>
          </Td>
          <Td>สดุดี 126-128</Td>
          <Td>Ezekiel 36,37</Td>
          <Td>Psalms 126-128</Td>

          <Td>พระพรจากพระเจ้า</Td>
        </tr>
        <tr>
          <Td>323</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.38.THSV11">
              เอเสเคียล 38,39
            </a>
          </Td>
          <Td>2 เปโตร 3</Td>
          <Td>Ezekiel38,39</Td>
          <Td>2 Peter 3</Td>

          <Td>สู่อนาคต</Td>
        </tr>
        <tr>
          <Td>324</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.40.THSV11">
              เอเสเคียล 40,41
            </a>
          </Td>
          <Td>1 ยอห์น 1</Td>
          <Td>Ezekiel 40,41</Td>
          <Td>1 John 1</Td>

          <Td>
            <p>สำรวจตรวจวัด</p>
          </Td>
        </tr>
        <tr>
          <Td>325</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.42.THSV11">
              เอเสเคียล 42,43
            </a>
          </Td>
          <Td>1 ยอห์น 2</Td>
          <Td>Ezekiel 42,43</Td>
          <Td>1 John 2</Td>

          <Td>แสงที่ส่องสว่าง</Td>
        </tr>
        <tr>
          <Td>326</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.44.THSV11">
              เอเสเคียล 44,45
            </a>
          </Td>
          <Td>สดุดี 129-131</Td>
          <Td>Ezekiel 44,45</Td>
          <Td>Psalms 129-131</Td>

          <Td>ต่อหน้าพระพักตร์</Td>
        </tr>
        <tr>
          <Td>327</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.46.THSV11">
              เอเสเคียล 46,47
            </a>
          </Td>
          <Td>1 ยอห์น 3</Td>
          <Td>Ezekiel 46,47</Td>
          <Td>1 John 3</Td>

          <Td>เต็มล้นด้วยใจขอบพระคุณ</Td>
        </tr>
        <tr>
          <Td>328</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/EZK.48.THSV11">
              เอเสเคียล 48
            </a>
          </Td>
          <Td>1 ยอห์น 4</Td>
          <Td>Ezekiel 48</Td>
          <Td>1 John 4</Td>

          <Td>เราไม่โดเดี่ยว</Td>
        </tr>
        <tr>
          <Td>329</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/DAN.1.THSV11">
              ดาเนียล 1-3
            </a>
          </Td>
          <Td>สดุดี 132-134</Td>
          <Td>Daniel 1-3</Td>
          <Td>Psalms 132-134</Td>

          <Td>การทรงสำแดง</Td>
        </tr>
        <tr>
          <Td>330</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/DAN.4.THSV11">
              ดาเนียล 4,5
            </a>
          </Td>
          <Td>1 ยอห์น 5</Td>
          <Td>Daniel 4,5</Td>
          <Td>1 John 5</Td>

          <Td>ไม่เพียงแต่ฝัน</Td>
        </tr>
        <tr>
          <Td>331</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/DAN.6.THSV11">
              ดาเนียล 6,7
            </a>
          </Td>
          <Td>2 ยอห์น</Td>
          <Td>Daniel 6,7</Td>
          <Td>2 John</Td>

          <Td>ต้องการคำิ่งอธิบาย</Td>
        </tr>
        <tr>
          <Td>332</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/DAN.8.THSV11">
              ดาเนียล 8,9
            </a>
          </Td>
          <Td>3 ยอห์น</Td>
          <Td>Daniel 8,9</Td>
          <Td>3 John</Td>

          <Td>เข้าใจความจริง</Td>
        </tr>
        <tr>
          <Td>333</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/DAN.10.THSV11">
              ดาเนียล 10-12
            </a>
          </Td>
          <Td>สดุดี 135,136</Td>
          <Td>Daniel 10-12</Td>
          <Td>Psalms 135,136</Td>

          <Td>สัตย์ซื่อถึงที่สุด</Td>
        </tr>
        <tr>
          <Td>334</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/HOS.1.THSV11">
              โฮเซยา 1,2
            </a>
          </Td>
          <Td>ยูดาห์ 1</Td>
          <Td>Hosea 1,2</Td>
          <Td>Jude 1</Td>

          <Td>ความรักชนะทุกส</Td>
        </tr>
        <tr>
          <Td>335</Td>
          <Td>
            <a href="https://www.bible.com/th/bible/174/HOS.3.THSV11">
              โฮเซยา <br />
              3-6
            </a>
          </Td>
          <Td>วิวรณ์ 1</Td>
          <Td>Hosea 3-6</Td>
          <Td>Revelation 1</Td>

          <Td>ความจริงเปิดเผย</Td>
        </tr>
      </Tbody>
    </Table>
  );
};

export default ThreeZeroSixToThreeThreeFive;
